import React, {useEffect, useState} from 'react';
import './Languages.scss';
import RadioMUI from '../../../../shared/RadioMUI';
import {patchProfileMeSettings} from '../../../../redux/actions/profile/profileActions';
import {getProfileMe} from '../../../../redux/actions/profile/profileActions';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {notifySuccess} from '../../../../helpers/notifySnack';

const Languages = () => {
  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();

  const profileMe = useSelector((state) => state.profile.profileMe);

  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    if (profileMe?.language) {
      setLanguage(profileMe.language);
      i18n.changeLanguage(profileMe.language);
    }
  }, [profileMe, i18n]);

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem('langD', selectedLanguage);

    dispatch(patchProfileMeSettings({language: selectedLanguage})).then(() => {
      dispatch(getProfileMe());
      notifySuccess(t('languages.languagesChanges'));
    });
  };

  const languages = [
    {id: 'uk', name: t('languages.ua')},
    {id: 'ru', name: t('languages.ru')},
    {id: 'en', name: t('languages.en')}
  ];

  return (
    <div className='user-settings__block radio'>
      <div className='user-settings__block-title'>{t('profileSettings.languageTitle')}</div>
      <div className='user-settings__radio'>
        {languages.map(({id, name}) => (
          <RadioMUI key={id} checked={language === id} onChange={handleLanguageChange} value={id} label={name} />
        ))}
      </div>
    </div>
  );
};

export default Languages;
